<template>
    <div :class="['status', status]">
        {{ statusLabel }}
    </div>
</template>

<script lang="ts">
export const StatusMap = {
    active: "blue",
    draft: "gray",
    deleted: "red",
    inactive: "gray"
} as const;
</script>

<script lang="ts" setup>
type Props = {
    status: "red" | "green" | "gray" | "blue";
    statusLabel: string;
};

const { statusLabel } = defineProps<Props>();
</script>

<style scoped>
.status {
    font-weight: 500;

    border-radius: 4px;
    padding: 2px 8px;
}

.green {
    color: var(--wpp-success-color-500);
    background-color: var(--wpp-success-color-200);
}

.gray {
    color: var(--wpp-grey-color-600);
    background-color: var(--wpp-grey-color-300);
}

.blue {
    color: var(--wpp-primary-color-500);
    background-color: var(--wpp-primary-color-100);
}

.red {
    color: var(--wpp-danger-color-500);
    background-color: var(--wpp-danger-color-200);
}
</style>
